import { gql } from 'graphql-request';

/**
 * GraphQL mutation for adding a new page
 */
export const addPageMutation = gql`
  mutation AddPage($input: PageInput!) {
    addPage(input: $input) {
      id
      subslug
      pricing_page_url
      created_at
    }
  }
`;

/**
 * Type for the add page input
 */
export interface AddPageInput {
  subslug?: string;
  pricing_page_url?: string;
  company_id: string;
}

/**
 * Type for the add page response
 */
export interface AddPageResponse {
  addPage: {
    id: string;
    subslug?: string;
    pricing_page_url?: string;
    created_at?: string;
  };
}